module.exports = __webpack_public_path__ + "static/media/gmn-qc2-dept.07a41188.png";